// Define available filter types
export enum FilterType {
  PEOPLE = 'people',
  SESSIONS = 'sessions',
}

// Define filter structure type
export interface FilterConfig {
  name: string;
  attribute: string;
  operator: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: any;
  enabled: boolean;
  i18nPath?: string;
}
